import React from "react"

//helpery potrzebne tylko dla BO

export const withAutoFill = Component => props => <Component {...props} autofill={false} />